import VerticalNavigationMenuContainer from './VerticalNavigationMenu';
export default VerticalNavigationMenuContainer